import React from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom'; // <-- Import Link

// Import slick carousel and theme styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './HowItWorksSection.css'; 

// Accept isLoggedIn as a prop
const HowItWorksSection = ({ isLoggedIn }) => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true
  };

  const howItWorksData = [
    {
      number: '01',
      icon: '/photos/sh1.png',
      title: 'Create Your Profile',
      description: 'Share your academic background, test scores, interests, and budget to kickstart your journey.',
    },
    {
      number: '02',
      icon: '/photos/sh2.png',
      title: 'AI-Powered Matching',
      description: 'Our algorithm instantly scans 1,000+ colleges across 50+ countries to find your best fits.',
    },
    {
      number: '03',
      icon: '/photos/sh3.png',
      title: 'Receive Your Report',
      description: 'Get a customized visa report with top country & university picks, cost breakdowns, and scholarship options.',
    },
    {
      number: '04',
      icon: '/photos/sh4.png',
      title: 'Expert Consultation',
      description: 'Book a one-on-one call with our study-abroad specialists for tailored advice and next-step support.',
    },
  ];

  return (
    <section className="why-section">
      <div className="why-container container">
        <h2 className="section-title">How It Works</h2>
        <p className="section-description">
          Our AI-powered platform provides comprehensive insights to make your study abroad journey successful.
        </p>

        {/* Slider for Mobile View (max-width: 425px) */}
        <div className="hiw-slider-mobile-view">
          <Slider {...sliderSettings}>
            {howItWorksData.map((card, index) => (
              <div key={index} className="feat-card">
                <span className="card-number">{card.number}</span>
                <div className="feat-icon">
                  <img src={card.icon} alt={`${card.title} icon`} loading="lazy" />
                </div>
                <h3 className="feat-title">{card.title}</h3>
                <p className="feat-description">{card.description}</p>
              </div>
            ))}
          </Slider>
        </div>

        {/* Grid for Desktop and Tablet View */}
        <div className="hiw-grid-desktop-view">
          {howItWorksData.map((card, index) => (
            <div key={index} className="feat-card">
              <span className="card-number">{card.number}</span>
              <div className="feat-icon">
                <img src={card.icon} alt={`${card.title} icon`} loading="lazy" />
              </div>
              <h3 className="feat-title">{card.title}</h3>
              <p className="feat-description">{card.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* --- MODIFICATION HERE --- */}
      {/* Conditionally render a Link or the original anchor tag */}
      {isLoggedIn ? (
        <Link 
          to="/dashboard" 
          className="primary-btn" 
          aria-label="Learn More"
          style={{ display: "flex", width: "fit-content", justifyContent: "center", margin: "0 auto", marginTop: "40px", cursor: "pointer" }}
        >
          Learn More →
        </Link>
      ) : (
        <a 
          className="primary-btn trigger-login-popup" 
          aria-label="Learn More"
          style={{ display: "flex", width: "fit-content", justifyContent: "center", margin: "0 auto", marginTop: "40px", cursor: "pointer" }}
        >
          Learn More →
        </a>
      )}
    </section>
  );
};

export default HowItWorksSection;